// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  background-color: #282a36;
  color: #f8f8f2;
  font-family: 'Segoe UI', sans-serif;
  margin: 0;
  padding: 0;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
}

#screen-warning {
  display: none;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 9999;
  color: #d32f2f;
  font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;
  text-align: center;
  padding: 20px;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

#screen-warning::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  backdrop-filter: blur(15px);
  -webkit-backdrop-filter: blur(15px);
  background-color: rgba(255, 255, 255, 0.7);
  z-index: -1;
}

#screen-warning strong {
  font-size: 48px;
  margin-bottom: 10px;
  display: block;
}

#screen-warning span {
  font-size: 1.1rem;
  font-weight: normal;
  color: #fff;
}

@media (max-width: 1200px) {
  #screen-warning {
    display: flex;
  }
  body {
    overflow: hidden;
  }
}

code {
  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;
}

.ip-list {
  padding: 25px;
}

header {
  background-color: #21222c;
  padding: 1rem;
  border-bottom: 1px solid #44475a;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.version {
  font-family: 'Roboto Mono', monospace;
  background: #282a36;
  color: #50fa7b;
}

@media (max-width: 700px) {
  .version {
    display: none;
  }
}

.rightHeader h1 {
  font-family: 'Inter', 'Segoe UI', sans-serif;
  font-weight: 700;
  font-size: 1.2rem;
  color: #f8f8f2;
  margin: 0;
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.highlight-box {
  background-color: #50fa7b1a;
  color: #50fa7b;
  padding: 0.3em 0.8em;
  border-radius: 0.5rem;
  font-family: 'Roboto Mono', monospace;
  font-size: 1.1em;
  letter-spacing: 0.03em;
  border: 1px solid #50fa7b44;
  box-shadow: inset 0 0 4px #50fa7b33;
  transition: background-color 0.2s, box-shadow 0.2s;
}

.highlight-box:hover {
  background-color: #50fa7b33;
  box-shadow: inset 0 0 6px #50fa7b55;
}

.dashboard {
  flex: 1 1;
  display: flex;
  padding: 2rem;
  gap: 2rem;
  flex-wrap: wrap;
  align-items: flex-start;
}

.input-card {
  background-color: #44475a;
  border-radius: 1rem;
  padding: 1.5rem;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  width: 400px;
  height: 700px;
}

.output-card {
  background-color: #44475a;
  border-radius: 1rem;
  padding: 1.5rem;
  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);
  flex: 1 1;
  min-width: 0;
  min-height: 700px;
}

.footer {
  color: #fff;
  text-align: center;
  padding: 1rem 0;
  font-family: 'Segoe UI', sans-serif;
  font-size: 0.9rem;
}

.footer a {
  color: #4dd0e1;
  text-decoration: none;
  font-weight: bold;
  transition: color 0.3s ease, text-shadow 0.3s ease;
}

.footer a:hover {
  color: #80deea;
  text-shadow: 0 0 8px rgba(128, 222, 234, 0.8);
}

.backend-error-banner {
  width: 100%;
  max-width: 1200px;
  margin: 1rem auto;
  background-color: #ff555530;

  color: #ff5555;
  padding: 1rem 2rem;
  font-family: 'Roboto Mono', monospace;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
  border-radius: 0.5rem;
}

.backend-error-banner strong {
  font-size: 1.05rem;
}

.backend-error-banner p {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.4;
  opacity: 0.9;
}

@keyframes slideDown {
  0% {
    transform: translateY(-20px);
    opacity: 0;
  }
  100% {
    transform: translateY(0);
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,cAAc;EACd,mCAAmC;EACnC,SAAS;EACT,UAAU;EACV,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,aAAa;EACb,cAAc;EACd,6DAA6D;EAC7D,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,2BAA2B;EAC3B,mCAAmC;EACnC,0CAA0C;EAC1C,WAAW;AACb;;AAEA;EACE,eAAe;EACf,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE;IACE,aAAa;EACf;EACA;IACE,gBAAgB;EAClB;AACF;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,gCAAgC;EAChC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,qCAAqC;EACrC,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE;IACE,aAAa;EACf;AACF;;AAEA;EACE,4CAA4C;EAC5C,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,2BAA2B;EAC3B,cAAc;EACd,oBAAoB;EACpB,qBAAqB;EACrB,qCAAqC;EACrC,gBAAgB;EAChB,sBAAsB;EACtB,2BAA2B;EAC3B,mCAAmC;EACnC,kDAAkD;AACpD;;AAEA;EACE,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,SAAO;EACP,aAAa;EACb,aAAa;EACb,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,uCAAuC;EACvC,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,uCAAuC;EACvC,SAAO;EACP,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,eAAe;EACf,mCAAmC;EACnC,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,kDAAkD;AACpD;;AAEA;EACE,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,2BAA2B;;EAE3B,cAAc;EACd,kBAAkB;EAClB,qCAAqC;EACrC,aAAa;EACb,sBAAsB;EACtB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE;IACE,4BAA4B;IAC5B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF","sourcesContent":["body {\n  background-color: #282a36;\n  color: #f8f8f2;\n  font-family: 'Segoe UI', sans-serif;\n  margin: 0;\n  padding: 0;\n  min-height: 100vh;\n  display: flex;\n  flex-direction: column;\n  overflow-y: auto;\n  overflow-x: hidden;\n}\n\n#screen-warning {\n  display: none;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 9999;\n  color: #d32f2f;\n  font-family: 'Segoe UI', Roboto, Helvetica, Arial, sans-serif;\n  text-align: center;\n  padding: 20px;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n}\n\n#screen-warning::before {\n  content: \"\";\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  backdrop-filter: blur(15px);\n  -webkit-backdrop-filter: blur(15px);\n  background-color: rgba(255, 255, 255, 0.7);\n  z-index: -1;\n}\n\n#screen-warning strong {\n  font-size: 48px;\n  margin-bottom: 10px;\n  display: block;\n}\n\n#screen-warning span {\n  font-size: 1.1rem;\n  font-weight: normal;\n  color: #fff;\n}\n\n@media (max-width: 1200px) {\n  #screen-warning {\n    display: flex;\n  }\n  body {\n    overflow: hidden;\n  }\n}\n\ncode {\n  font-family: source-code-pro, Menlo, Monaco, Consolas, 'Courier New', monospace;\n}\n\n.ip-list {\n  padding: 25px;\n}\n\nheader {\n  background-color: #21222c;\n  padding: 1rem;\n  border-bottom: 1px solid #44475a;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.version {\n  font-family: 'Roboto Mono', monospace;\n  background: #282a36;\n  color: #50fa7b;\n}\n\n@media (max-width: 700px) {\n  .version {\n    display: none;\n  }\n}\n\n.rightHeader h1 {\n  font-family: 'Inter', 'Segoe UI', sans-serif;\n  font-weight: 700;\n  font-size: 1.2rem;\n  color: #f8f8f2;\n  margin: 0;\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.highlight-box {\n  background-color: #50fa7b1a;\n  color: #50fa7b;\n  padding: 0.3em 0.8em;\n  border-radius: 0.5rem;\n  font-family: 'Roboto Mono', monospace;\n  font-size: 1.1em;\n  letter-spacing: 0.03em;\n  border: 1px solid #50fa7b44;\n  box-shadow: inset 0 0 4px #50fa7b33;\n  transition: background-color 0.2s, box-shadow 0.2s;\n}\n\n.highlight-box:hover {\n  background-color: #50fa7b33;\n  box-shadow: inset 0 0 6px #50fa7b55;\n}\n\n.dashboard {\n  flex: 1;\n  display: flex;\n  padding: 2rem;\n  gap: 2rem;\n  flex-wrap: wrap;\n  align-items: flex-start;\n}\n\n.input-card {\n  background-color: #44475a;\n  border-radius: 1rem;\n  padding: 1.5rem;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n  width: 400px;\n  height: 700px;\n}\n\n.output-card {\n  background-color: #44475a;\n  border-radius: 1rem;\n  padding: 1.5rem;\n  box-shadow: 0 0 20px rgba(0, 0, 0, 0.2);\n  flex: 1;\n  min-width: 0;\n  min-height: 700px;\n}\n\n.footer {\n  color: #fff;\n  text-align: center;\n  padding: 1rem 0;\n  font-family: 'Segoe UI', sans-serif;\n  font-size: 0.9rem;\n}\n\n.footer a {\n  color: #4dd0e1;\n  text-decoration: none;\n  font-weight: bold;\n  transition: color 0.3s ease, text-shadow 0.3s ease;\n}\n\n.footer a:hover {\n  color: #80deea;\n  text-shadow: 0 0 8px rgba(128, 222, 234, 0.8);\n}\n\n.backend-error-banner {\n  width: 100%;\n  max-width: 1200px;\n  margin: 1rem auto;\n  background-color: #ff555530;\n\n  color: #ff5555;\n  padding: 1rem 2rem;\n  font-family: 'Roboto Mono', monospace;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n  border-radius: 0.5rem;\n}\n\n.backend-error-banner strong {\n  font-size: 1.05rem;\n}\n\n.backend-error-banner p {\n  margin: 0;\n  font-size: 0.95rem;\n  line-height: 1.4;\n  opacity: 0.9;\n}\n\n@keyframes slideDown {\n  0% {\n    transform: translateY(-20px);\n    opacity: 0;\n  }\n  100% {\n    transform: translateY(0);\n    opacity: 1;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
